import {
  Configuration,
  DefaultApi,
  KnownIssueDto,
  CreateKnownIssueDto,
  UpdateKnownIssueDto,
} from '@cratehackers/api-client';
import { config } from '../config';
import { AppIdentifiers } from '../store/slices/token-state.slice';
import { getAppStore } from '../store/storeRef';
import { openApiFetchWrapper } from '../utils/openApiFetchWrapper';

class KnownIssuesApiService {
  private static getApiClient(): DefaultApi {
    const apiConfig = new Configuration({
      basePath: config.API_BASE_URL,
      accessToken: KnownIssuesApiService.getAuthToken(),
      fetchApi: openApiFetchWrapper,
    });
    return new DefaultApi(apiConfig);
  }

  private static getAuthToken(): string {
    const appToken = getAppStore().getState().tokenState[AppIdentifiers.App];
    return appToken && appToken.accessToken ? appToken.accessToken : '';
  }

  static async listActive(): Promise<KnownIssueDto[]> {
    const apiClient = KnownIssuesApiService.getApiClient();
    return await apiClient.knownIssueControllerListActive();
  }

  static async listAll(): Promise<KnownIssueDto[]> {
    const apiClient = KnownIssuesApiService.getApiClient();
    return await apiClient.knownIssueControllerListAll();
  }

  static async create(payload: CreateKnownIssueDto): Promise<KnownIssueDto> {
    const apiClient = KnownIssuesApiService.getApiClient();
    return await apiClient.knownIssueControllerCreate({
      createKnownIssueDto: payload,
    });
  }

  static async update(
    id: number,
    payload: UpdateKnownIssueDto,
  ): Promise<KnownIssueDto> {
    const apiClient = KnownIssuesApiService.getApiClient();
    return await apiClient.knownIssueControllerUpdate({
      id: id.toString(),
      updateKnownIssueDto: payload,
    });
  }

  static async remove(id: number): Promise<void> {
    const apiClient = KnownIssuesApiService.getApiClient();
    await apiClient.knownIssueControllerRemove({ id: id.toString() });
  }

  static async removePermanent(id: number): Promise<void> {
    const apiClient = KnownIssuesApiService.getApiClient();
    await apiClient.knownIssueControllerRemovePermanent({
      id: id.toString(),
    });
  }
}

export { KnownIssuesApiService as KnownIssuesApi };
export type { KnownIssueDto, CreateKnownIssueDto, UpdateKnownIssueDto };

const KnownIssuesApi = KnownIssuesApiService;
export default KnownIssuesApi;
